import React from "react";
import { Box, Grid } from "@mui/material";
import ToolTip from "../common/Tooltip";
import moment from "moment";
import "./weekDays.scss";
import { cloudType } from "../../redux/features/ImageConfigReducer";

const WeekDays = (props) => {
  const { days, training_dates, cloudType } = props;
  const handleDay = (day) => {
    if (cloudType === "GCP") {
      console.log("days----", props?.days);

      let days = `${moment(training_dates[0]?.session_start_date).format(
        "Do MMM YYYY"
      )}-${moment(training_dates[0]?.session_end_date).format(
        "Do MMM YYYY"
      )} from ${moment(training_dates[0]?.session_start_date)
        .add(15, "minutes")
        .format("hh:mm A")}-${moment(training_dates[0]?.session_end_date)
        .subtract(15, "minutes")
        .format("hh:mm A")}`;
      return props?.days?.includes(day) ? (
        <p style={{ whiteSpace: "pre-line" }} className="line-break">
          {days}
        </p>
      ) : (
        <p style={{ whiteSpace: "pre-line" }} className="line-break">
          Not Scheduled
        </p>
      );
    } else {
      let data = training_dates?.filter((item) => item.day === day);
      if (data?.length > 0) {
        let response = data.map((item, index) => {
          return `${moment(item?.session_start_date).format(
            "Do MMM YYYY"
          )}-${moment(item?.session_end_date).format(
            "Do MMM YYYY"
          )} from ${moment(item?.session_start_date)
            .add(15, "minutes")
            .format("hh:mm A")}-${moment(item?.session_end_date)
            .subtract(15, "minutes")
            .format("hh:mm A")} \n`;
        });
        return (
          <p style={{ whiteSpace: "pre-line" }} className="line-break">
            {response}
          </p>
        );
      } else {
        return "Not Scheduled";
      }
    }
  };
  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {" "}
        <ToolTip
          title={handleDay("Sun")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Sun")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Sun
            </Grid>
          }
        ></ToolTip>
        <ToolTip
          title={handleDay("Mon")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Mon")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Mon
            </Grid>
          }
        ></ToolTip>
        <ToolTip
          title={handleDay("Tue")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Tue")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Tue
            </Grid>
          }
        ></ToolTip>
        <ToolTip
          title={handleDay("Wed")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Wed")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Wed
            </Grid>
          }
        ></ToolTip>
        <ToolTip
          title={handleDay("Thu")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Thu")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Thu
            </Grid>
          }
        ></ToolTip>
        <ToolTip
          title={handleDay("Fri")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Fri")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Fri
            </Grid>
          }
        ></ToolTip>
        <ToolTip
          title={handleDay("Sat")}
          placement="right"
          arrow={true}
          content={
            <Grid
              className={
                days?.includes("All")
                  ? "activeDays medium_f_bold"
                  : days?.includes("Sat")
                  ? "activeDays medium_f_bold"
                  : "weeklyINActiveDays medium_f_bold"
              }
            >
              Sat
            </Grid>
          }
        ></ToolTip>
      </Grid>
    </>
  );
};

export default WeekDays;
